import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GroupProduct, GroupProductUpdate } from 'src/app/models/group';
import { ResponseBase } from 'src/app/models/response-base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductsGroupService {

  private URL = environment.GATEWAY + 'group/productsOfGroup';
   // private URL = 'http://af8878d6354674085a29c95ff68310d6-1912565702.us-east-1.elb.amazonaws.com/api/ProductsOfGroup';

  constructor(private http: HttpClient) { }

  getGroupsByGroup(groupGuid: string, cedenteId: number = 0) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    let cedenteIdParams = new HttpParams();
    cedenteIdParams = cedenteIdParams.append(`assignorId`, cedenteId.toString());
    return this.http.get<ResponseBase<GroupProduct[]>>(`${this.URL}/${groupGuid}`, {params: cedenteIdParams, headers });
  }

  addProducts(products: GroupProductUpdate) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.post<ResponseBase<boolean>>(`${this.URL}/create`, products, { headers });
  }

  updateProducts(products: GroupProductUpdate) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.put<ResponseBase<boolean>>(`${this.URL}/update`, products, { headers });
  }
}
